class ddLogin {
  static init(a) {
    const c = document.createElement("iframe");
    let d = `https://login.dingtalk.com/login/qrcode.htm?goto=${a.goto}`;
    d += a.style ? `&style=${encodeURIComponent(a.style)}` : "";
    d += a.href ? `&href=${a.href}` : "";
    c.src = d;
    c.frameBorder = "0";
    c.allowTransparency = "true";
    c.scrolling = "no";
    c.width = a.width ? `${a.width}px` : "300px";
    c.height = a.height ? `${a.height}px` : "400px";
    const e = document.getElementById(a.id);
    e.innerHTML = "";
    e.appendChild(c);
  }
}

export default ddLogin;



// WEBPACK FOOTER //
// ./src/AntD/utils/ddLogin.js